/**
 * External dependencies
 */
import React from "react";
import { Box } from "@towersystems/towersystems-design-system";
import { get } from "lodash";

/**
 * Internal dependencies
 */
import useReportBuilder from "modules/report-builder/use-report-builder";
import FormInputCheckbox from "components/forms/form-checkbox";

const ConfigureRowTotals = () => {
  const { report, editReport } = useReportBuilder();

  const handleChange = (e) => {
    editReport({ config: { rowTotals: !get(report, "config.rowTotals") } });
  };

  return (
    <Box>
      <FormInputCheckbox
        onChange={handleChange}
        label="Show row totals"
        checked={!!get(report, "config.rowTotals")}
      />
    </Box>
  );
};

export default ConfigureRowTotals;
